import styled from "styled-components";

type ContainerType = {
  background: string;
};

type SectionType = {
  border: string;
  background: string;
};

type ButtonType = {
  color: string;
  background: string;
  border: string;
  accent: string;
  active?: boolean;
};

type TextType = {
  color: string;
};

type IconCircleType = {
  background: string;
};

type BadgeType = {
  color: string;
  background: string;
};

type PeriodInputWrapperType = {
  iconcolor?: string;
};

type PeriodsRowType = {
  gradientstart?: string;
};

type DividerType = {
  border: string;
};

export const ContentFilter = styled.div<ContainerType>`
  display: flex;
  background: ${(props) => props.background};
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  margin-top: 1px;
`;

export const FilterSection = styled.div<SectionType>`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.border};
  border-radius: 10px;
  background: ${(props) => props.background};
`;

export const PeriodsRow = styled.div<PeriodsRowType>`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  border-radius: 10px;
  background: ${(props) => props.gradientstart
    ? `linear-gradient(90deg, ${props.gradientstart} 0%, ${props.gradientstart} 35%, transparent 60%)`
    : 'transparent'};
`;

export const PeriodBlock = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  padding: 20px;
`;

export const PeriodHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const IconCircle = styled.div<IconCircleType>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background: ${(props) => props.background};
`;

export const PeriodTitle = styled.span<TextType>`
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => props.color};
  line-height: 1.2;
`;

export const PeriodBadge = styled.span<BadgeType>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  color: ${(props) => props.color};
  background: ${(props) => props.background};
  white-space: nowrap;
`;

export const PeriodInputsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
`;

export const PeriodInputWrapper = styled.div<PeriodInputWrapperType>`
  flex: 1;
  min-width: 0;

  .ant-picker-suffix {
    color: ${(props) => props.iconcolor ?? 'inherit'} !important;
  }
`;

export const PeriodSeparator = styled.span<TextType>`
  font-size: 13px;
  color: ${(props) => props.color};
  white-space: nowrap;
  margin-top: 10px;
`;

export const DurationDivider = styled.div<DividerType>`
  width: 100%;
  height: 1px;
  background: ${(props) => props.border};
  margin-top: 2px;
`;

export const DurationRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const DurationText = styled.span<TextType>`
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.color};
  line-height: 1.2;
`;

export const PresetsContent = styled.div<SectionType>`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 0px;
  border: 1px solid ${(props) => props.border};
  border-radius: 10px;
  background: ${(props) => props.background};
`;

export const PresetsLabel = styled.span<TextType>`
  font-size: 13px;
  font-weight: 700;
  color: ${(props) => props.color};
  white-space: nowrap;
  margin-right: 4px;
`;

export const PresetButton = styled.button<ButtonType>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border-radius: 6px;
  border: 1px solid ${(props) => props.active ? props.accent : props.border};
  background: ${(props) => props.active ? props.accent : props.background};
  color: ${(props) => props.active ? '#FFFFFF' : props.color};
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: ${(props) => props.accent};
  }
`;
